package team.platforma.materialextension.screen

import androidx.compose.runtime.Composable
import team.platforma.materialextension.sample_screens.ButtonsSample
import team.platforma.materialextension.sample_screens.CalendarViewSample
import team.platforma.materialextension.sample_screens.ListScreen
import team.platforma.materialextension.sample_screens.OneTapScreen
import team.platforma.materialextension.sample_screens.PersonalDataPhoneTestSample
import team.platforma.materialextension.sample_screens.PersonalDataSample
import team.platforma.materialextension.sample_screens.SignInSample
import team.platforma.materialextension.sample_screens.SmsCodeSample
import team.platforma.materialextension.sample_screens.WebView

sealed class Screens(val title: String, val route: String, val screen: @Composable () -> Unit)
data object SignSample : Screens(
    title = "Sign in sample", route = "sign_in", screen = { SignInSample() }
)

data object SmsCodeSample : Screens(
    title = "Sms code sample", route = "sms_code", screen = { SmsCodeSample() }
)

data object PersonalData : Screens(
    title = "Personal Data", route = "personal_data", screen = { PersonalDataSample() }
)

data object CalendarView : Screens(
    title = "Calendar view", route = "calendar_view", screen = { CalendarViewSample() }
)

data object TrashDebug : Screens(
    title = "Buttons sample", route = "buttons_sample", screen = { ButtonsSample() }
)

data object PersonalDataPhoneTest : Screens(
    title = "Personal Data (phone test)",
    route = "personal_data_phone_test",
    screen = { PersonalDataPhoneTestSample() }
)

data object WebViewTest : Screens(
    title = "WebView", route = "web_view_test", screen = { WebView() }
)

data object ListScreenDebug : Screens(
    title = "List Screen", route = "list_screen", screen = { ListScreen() }
)

data object OneTap :
    Screens(title = "Telegram One Tap", route = "one_tap", screen = { OneTapScreen() }
    )
